import * as $ from 'jquery';

$(document).ready(() => {
    $('select#my-work-employee-select').on('change', function () {
        const params = new URLSearchParams(window.location.search);
        params.set('user_id', $(this).val());
        window.location = `${window.location.pathname}?${params}`;
    });
});
